import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { requireAuth } from "@/lib/auth";
import { useResume } from "@/components/GoogleReturn";

export default function OwnerInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [bad, setBad] = useState(false);
  const [ok, setOk] = useState(false);
  useEffect(() => { api.get(`/owner-invites/${token}`).then((r) => setInv(r.data)).catch(() => setBad(true)); }, [token]);

  const doClaim = useCallback(async () => {
    try { const { data } = await api.get(`/owner-invites/${token}`); await api.post("/owner-claims", { inviteToken: token, statement: "I own or manage this property." }); nav(`/m/${data.proposalId}`); } catch (e) { toast(errMsg(e, "Couldn't record the claim.")); }
  }, [token, nav]);
  useResume(`owner:${token}`, doClaim);
  const claim = () => requireAuth("Claim this property", doClaim, `owner:${token}`);

  if (bad) return <main className="mx-auto max-w-3xl px-5 py-28" data-testid="owner-invite-invalid"><p className="font-display text-4xl">This invite link isn't valid.</p></main>;
  return (
    <main className="mx-auto max-w-2xl px-5 py-20 sm:py-28" data-testid="owner-invite-page">
      <div className="eyebrow mb-3">You've been invited</div>
      <h1 className="font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl">Someone has a vision for your property.</h1>
      <p className="mt-5 text-[var(--stone-dark)]">Review the proposal, see what the community would support, and decide. Nothing is binding and no money changes hands here.</p>
      <label className="mt-8 flex items-start gap-3 text-sm"><input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-1" data-testid="owner-attest-checkbox" /> I own or manage this property. I understand this is a self-attested claim — not proof of ownership.</label>
      <div className="mt-6 flex flex-wrap gap-2">
        <button className="btn-primary" disabled={!inv || !ok} onClick={claim} data-testid="owner-claim-button">Claim and review</button>
        {inv && <button className="btn-quiet" onClick={() => nav(`/m/${inv.proposalId}`)} data-testid="owner-view-proposal">Just view the proposal</button>}
      </div>
    </main>
  );
}
